import YouInvest from './YouInvest';
import axios from 'axios';
import { EQUITY, FUND, ETF, CEF } from './Graphql';
import { CACHE_TIME_15_MINUTES } from '../Cache/RedisCache';
import RedisCaching from './RedisCaching';

const { compress, decompress } = require('shrink-string');

const SCREENER_FILTERS_CACHE_KEY = 'SCREENER_FILTERS';

const FUND_MANAGER_DATA = [
  { "id": "7IM", "name": "7IM", "value": ["0C000048YX"] },
  {
    "id": "Aberforth Unit Trust Managers",
    "name": "Aberforth Unit Trust Managers",
    "value": ["0C000020JJ", "0C00001KB2"]
  },
  {
    "id": "Abrdn",
    "name": "Abrdn",
    "value": [
      "0C0000AVFW",
      "0C00001D04",
      "0C0000CCU7",
      "0C0000AOEH",
      "0C00001KAX",
      "0C00001UOL",
      "0C00000MSX",
      "0C0000APTK"
    ]
  },
  {
    "id": "Aegon Asset Management",
    "name": "Aegon Asset Management",
    "value": ["0C000092S5", "0C00001KF9"]
  },
  {
    "id": "Aikya Investment Management Limited",
    "name": "Aikya Investment Management Limited",
    "value": ["0C0000BZN1"]
  },
  {
    "id": "Algebris Investments",
    "name": "Algebris Investments",
    "value": ["0C00002EKZ"]
  },
  {
    "id": "Allianz Global Investors",
    "name": "Allianz Global Investors",
    "value": ["0C00001KKO", "0C0000AS5X", "0C0000ARZK"]
  },
  {
    "id": "Alpha Real Capital LLP",
    "name": "Alpha Real Capital LLP",
    "value": ["0C000021XS"]
  },
  {
    "id": "Alquity Investment Management Limited",
    "name": "Alquity Investment Management Limited",
    "value": ["0C00008VT7"]
  },
  {
    "id": "Amati Global Investors Ltd",
    "name": "Amati Global Investors Ltd",
    "value": ["0C0000688M"]
  },
  {
    "id": "Amundi Asset Management",
    "name": "Amundi Asset Management",
    "value": ["0C000068ZH", "0C0000563H", "0C0000BMWH"]
  },
  {
    "id": "AQR Capital Management",
    "name": "AQR Capital Management",
    "value": ["0C00001SWY"]
  },
  {
    "id": "Ardevora Asset Management LLP",
    "name": "Ardevora Asset Management LLP",
    "value": ["0C00008THD"]
  },
  {
    "id": "Artemis",
    "name": "Artemis",
    "value": ["0C00001KTV", "0C000034EW"]
  },
  {
    "id": "Artisan Partners Global Funds PLC",
    "name": "Artisan Partners Global Funds PLC",
    "value": ["0C0000921C"]
  },
  {
    "id": "Ashmore Investment Management",
    "name": "Ashmore Investment Management",
    "value": ["0C0000BQCK"]
  },
  {
    "id": "Atlantic House Fund Management",
    "name": "Atlantic House Fund Management",
    "value": ["0C0000CEFH"]
  },
  {
    "id": "Aviva Investors",
    "name": "Aviva Investors",
    "value": ["0C000033FK", "0C00001UPC"]
  },
  { "id": "AXA", "name": "AXA", "value": ["0C00001KZL", "0C00001T6S"] },
  {
    "id": "Baillie Gifford",
    "name": "Baillie Gifford",
    "value": ["0C0000341K", "0C0000BKEZ"]
  },
  {
    "id": "Barclays Wealth",
    "name": "Barclays Wealth",
    "value": ["0C0000AO5T", "0C00000PK3"]
  },
  {
    "id": "Barings",
    "name": "Barings",
    "value": ["0C00002EWK", "0C00001LCB", "0C000034Z8"]
  },
  {
    "id": "BlackRock",
    "name": "BlackRock",
    "value": [
      "0C000034YC",
      "0C00001LJV",
      "0C0000AUB6",
      "0C00001LBD",
      "0C0000AUB8",
      "0C00004AQA",
      "0C00001LK3",
      "0C000034EF"
    ]
  },
  { "id": "Blue Whale", "name": "Blue Whale", "value": ["0C0000BFJJ"] },
  {
    "id": "BNY Mellon",
    "name": "BNY Mellon",
    "value": ["0C00009VY6", "0C000035YS"]
  },
  {
    "id": "Brandes Investment Partners (Europe) Limited",
    "name": "Brandes Investment Partners (Europe) Limited",
    "value": ["0C0000AF74"]
  },
  {
    "id": "Bridge Fund Management Limited",
    "name": "Bridge Fund Management Limited",
    "value": ["0C0000BLEN"]
  },
  {
    "id": "Brooks Macdonald",
    "name": "Brooks Macdonald",
    "value": ["0C00009OMR", "0C0000C1F2"]
  },
  {
    "id": "Brown Advisory",
    "name": "Brown Advisory",
    "value": ["0C0000BRS0", "0C00001KJC"]
  },
  {
    "id": "Canaccord Genuity Wealth Management",
    "name": "Canaccord Genuity Wealth Management",
    "value": ["0C0000CT02"]
  },
  {
    "id": "Capita Financial Managers (Ireland) Ltd",
    "name": "Capita Financial Managers (Ireland) Ltd",
    "value": ["0C00001UQM"]
  },
  {
    "id": "Carmignac Group",
    "name": "Carmignac Group",
    "value": ["0C00001M0G"]
  },
  {
    "id": "Carne Global Fund Managers (Ireland) Ltd",
    "name": "Carne Global Fund Managers (Ireland) Ltd",
    "value": ["0C00009T6U", "0C00004DF8"]
  },
  {
    "id": "Castellain Capital LLP",
    "name": "Castellain Capital LLP",
    "value": ["0C00009LUD"]
  },
  {
    "id": "CCLA Investment Management Ltd",
    "name": "CCLA Investment Management Ltd",
    "value": ["0C00001M2D"]
  },
  {
    "id": "Cerno Capital",
    "name": "Cerno Capital",
    "value": ["0C000097O2"]
  },
  {
    "id": "CG Asset Management",
    "name": "CG Asset Management",
    "value": ["0C00001M3U"]
  },
  {
    "id": "Chelverton Asset Management",
    "name": "Chelverton Asset Management",
    "value": ["0C00001M52"]
  },
  {
    "id": "Church House Investment Management",
    "name": "Church House Investment Management",
    "value": ["0C0000B21I"]
  },
  {
    "id": "Close Asset Management (UK) Limited",
    "name": "Close Asset Management (UK) Limited",
    "value": ["0C00004AWR"]
  },
  {
    "id": "Cohen & Steers",
    "name": "Cohen & Steers",
    "value": ["0C0000BY7Q"]
  },
  {
    "id": "Colchester Global Investors Ltd",
    "name": "Colchester Global Investors Ltd",
    "value": ["0C00001CXK"]
  },
  {
    "id": "Columbia Threadneedle",
    "name": "Columbia Threadneedle",
    "value": ["0C0000BPUQ", "0C00001TLX", "0C0000B0CH", "0C0000B9ML"]
  },
  {
    "id": "Comgest Asset Management International Limited",
    "name": "Comgest Asset Management International Limited",
    "value": ["0C00001MDH"]
  },
  {
    "id": "ConBrio Fund Partners Limited",
    "name": "ConBrio Fund Partners Limited",
    "value": ["0C0000BXZU"]
  },
  { "id": "Consistent", "name": "Consistent", "value": ["0C00001MG0"] },
  {
    "id": "Contrarius Investment Management Ltd",
    "name": "Contrarius Investment Management Ltd",
    "value": ["0C00004HJK"]
  },
  {
    "id": "COURTIERS Asset Management Ltd",
    "name": "COURTIERS Asset Management Ltd",
    "value": ["0C0000B1GD"]
  },
  {
    "id": "Credo Capital Limited",
    "name": "Credo Capital Limited",
    "value": ["0C00008KRA"]
  },
  {
    "id": "CRUX Asset Management",
    "name": "CRUX Asset Management",
    "value": ["0C0000AVQX"]
  },
  {
    "id": "Diamond Capital Management (Singapore) Pte Ltd",
    "name": "Diamond Capital Management (Singapore) Pte Ltd",
    "value": ["0C000099AA"]
  },
  {
    "id": "Dimensional Fund Advisors Ltd",
    "name": "Dimensional Fund Advisors Ltd",
    "value": ["0C00001CV4"]
  },
  { "id": "Dodge & Cox", "name": "Dodge & Cox", "value": ["0C00001MX8"] },
  {
    "id": "Dragon Capital Management (HK) Limited",
    "name": "Dragon Capital Management (HK) Limited",
    "value": ["0C0000ADAI"]
  },
  {
    "id": "Eaton Vance Global Advisors Limited",
    "name": "Eaton Vance Global Advisors Limited",
    "value": ["0C0000BS36"]
  },
  { "id": "EdenTree", "name": "EdenTree", "value": ["0C00001N1O"] },
  {
    "id": "EPIC Funds plc",
    "name": "EPIC Funds plc",
    "value": ["0C000020KS"]
  },
  { "id": "Equitile", "name": "Equitile", "value": ["0C0000B2WU"] },
  {
    "id": "Equity Trustees Limited",
    "name": "Equity Trustees Limited",
    "value": ["0C0000BMAK", "0C0000911R"]
  },
  {
    "id": "Eurizon SLJ Capital LTD",
    "name": "Eurizon SLJ Capital LTD",
    "value": ["0C0000B52Z"]
  },
  {
    "id": "Evelyn Partners",
    "name": "Evelyn Partners",
    "value": ["0C00001UWC"]
  },
  {
    "id": "Federated Hermes Investment Management",
    "name": "Federated Hermes Investment Management",
    "value": ["0C000035S5"]
  },
  {
    "id": "Ferox Capital LLP",
    "name": "Ferox Capital LLP",
    "value": ["0C00008PA8"]
  },
  {
    "id": "Fidelity",
    "name": "Fidelity",
    "value": ["0C00001SZ3", "0C000022C9"]
  },
  {
    "id": "Fiera Capital",
    "name": "Fiera Capital",
    "value": ["0C00001M47"]
  },
  {
    "id": "Findlay Park Partners LLP",
    "name": "Findlay Park Partners LLP",
    "value": ["0C00001NGD"]
  },
  {
    "id": "FIL",
    "name": "FIL",
    "value": [
      "0C00001NF3",
      "0C0000AIY8",
      "0C00001TI9",
      "0C000053WD",
      "0C00001NF4"
    ]
  },
  {
    "id": "First Sentier Investments",
    "name": "First Sentier Investments",
    "value": ["0C00002I6X", "0C00002I1B", "0C0000BQP1"]
  },
  {
    "id": "Foresight",
    "name": "Foresight",
    "value": ["0C00009OWE", "0C000020KZ"]
  },
  {
    "id": "Fortem Capital Limited",
    "name": "Fortem Capital Limited",
    "value": ["0C0000BCV5"]
  },
  {
    "id": "Franklin Templeton",
    "name": "Franklin Templeton",
    "value": ["0C0000BIKL", "0C0000A3Z2", "0C0000AL13", "0C0000C7MY"]
  },
  {
    "id": "FundRock",
    "name": "FundRock",
    "value": ["0C0000CSBU", "0C00001TNZ", "0C00001USO"]
  },
  { "id": "Fundsmith", "name": "Fundsmith", "value": ["0C00008FGG"] },
  {
    "id": "GAM",
    "name": "GAM",
    "value": ["0C000049HR", "0C00001NRW", "0C00001TAG"]
  },
  {
    "id": "Garraway Capital Management LL",
    "name": "Garraway Capital Management LL",
    "value": ["0C0000AZ8G"]
  },
  {
    "id": "Gemini Capital Management (Ireland) Limited",
    "name": "Gemini Capital Management (Ireland) Limited",
    "value": ["0C0000BFI7"]
  },
  {
    "id": "Goldman Sachs",
    "name": "Goldman Sachs",
    "value": ["0C00001OJY", "0C0000BNFE", "0C00001ETL"]
  },
  {
    "id": "Gresham House",
    "name": "Gresham House",
    "value": ["0C0000B0TU"]
  },
  {
    "id": "Guinness Asset Management Limited",
    "name": "Guinness Asset Management Limited",
    "value": ["0C00001O33"]
  },
  {
    "id": "GuardCap Asset Management Limited",
    "name": "GuardCap Asset Management Limited",
    "value": ["0C0000AX9S"]
  },
  {
    "id": "GVQ Investment Management Limited",
    "name": "GVQ Investment Management Limited",
    "value": ["0C000020MS"]
  },
  {
    "id": "Handelsbanken ACD Limited",
    "name": "Handelsbanken ACD Limited",
    "value": ["0C0000CAOA"]
  },
  {
    "id": "Hargreaves Lansdown",
    "name": "Hargreaves Lansdown",
    "value": ["0C00001O60"]
  },
  {
    "id": "Havelock London",
    "name": "Havelock London",
    "value": ["0C0000BHB0"]
  },
  {
    "id": "HBOS Investment Fund Managers Limited",
    "name": "HBOS Investment Fund Managers Limited",
    "value": ["0C00001O79"]
  },
  {
    "id": "Heptagon Capital Limited",
    "name": "Heptagon Capital Limited",
    "value": ["0C0000AK7I"]
  },
  {
    "id": "Herald Investment Fund",
    "name": "Herald Investment Fund",
    "value": ["0C00001O8R"]
  },
  {
    "id": "Heritage Capital Management Ltd",
    "name": "Heritage Capital Management Ltd",
    "value": ["0C00009OI3"]
  },
  {
    "id": "Hermes Fund Managers Ireland Ltd",
    "name": "Hermes Fund Managers Ireland Ltd",
    "value": ["0C0000BNZ1"]
  },
  { "id": "HSBC", "name": "HSBC", "value": ["0C00001OCM", "0C00001OD3"] },
  {
    "id": "Impax Asset Management Ltd",
    "name": "Impax Asset Management Ltd",
    "value": ["0C00000NY9", "0C00001OIC"]
  },
  {
    "id": "Invesco",
    "name": "Invesco",
    "value": ["0C00001OOC", "0C000033PF", "0C0000AFFH", "0C000033PS"]
  },
  {
    "id": "Investment Fund Services Limited",
    "name": "Investment Fund Services Limited",
    "value": ["0C0000185D", "0C00009ENX"]
  },
  {
    "id": "IQ EQ Fund Management (Ireland) Limited",
    "name": "IQ EQ Fund Management (Ireland) Limited",
    "value": ["0C0000BS4X"]
  },
  {
    "id": "Iridian Asset Management LLC",
    "name": "Iridian Asset Management LLC",
    "value": ["0C00001OQH"]
  },
  {
    "id": "Janus Henderson",
    "name": "Janus Henderson",
    "value": ["0C0000B9OA", "0C00001IR4"]
  },
  {
    "id": "JOHCM Funds",
    "name": "JOHCM Funds",
    "value": ["0C0000C1JR", "0C0000BMZO"]
  },
  {
    "id": "JK Investment Management",
    "name": "JK Investment Management",
    "value": ["0C00006HAO"]
  },
  {
    "id": "JPMorgan Asset Management",
    "name": "JPMorgan Asset Management",
    "value": ["0C0000AGS4", "0C00008F1P"]
  },
  {
    "id": "Jupiter",
    "name": "Jupiter",
    "value": [
      "0C0000BLZH",
      "0C0000BMY1",
      "0C0000BM1V",
      "0C00009W00",
      "0C00001OX6"
    ]
  },
  {
    "id": "KBA Consulting Management Limited",
    "name": "KBA Consulting Management Limited",
    "value": ["0C0000B1BV"]
  },
  {
    "id": "KBI Global Investors Ltd",
    "name": "KBI Global Investors Ltd",
    "value": ["0C0000B5C3"]
  },
  {
    "id": "Lazard Fund Managers Limited",
    "name": "Lazard Fund Managers Limited",
    "value": ["0C00001P6H", "0C0000BN3H"]
  },
  {
    "id": "Legal & General",
    "name": "Legal & General",
    "value": ["0C00001P7B"]
  },
  {
    "id": "LGT Wealth Management UK LLP",
    "name": "LGT Wealth Management UK LLP",
    "value": ["0C0000B4O6"]
  },
  {
    "id": "Lindsell Train",
    "name": "Lindsell Train",
    "value": ["0C00001PAA"]
  },
  {
    "id": "Link Asset Services",
    "name": "Link Asset Services",
    "value": ["0C00003J3Q", "0C0000BDUH"]
  },
  {
    "id": "Liontrust",
    "name": "Liontrust",
    "value": ["0C00006IGC", "0C00006IGF", "0C0000CRRP"]
  },
  {
    "id": "Lord Abbett (Ireland) Ltd",
    "name": "Lord Abbett (Ireland) Ltd",
    "value": ["0C0000BJYW"]
  },
  {
    "id": "Lowes Financial Management Limited",
    "name": "Lowes Financial Management Limited",
    "value": ["0C0000B3VG"]
  },
  {
    "id": "M&G",
    "name": "M&G",
    "value": ["0C0000BDTY", "0C0000BIX5", "0C00001PES"]
  },
  {
    "id": "Macquarie",
    "name": "Macquarie",
    "value": ["0C0000490Q", "0C0000B8MI", "0C0000BKAT"]
  },
  {
    "id": "Maitland Institutional Services Ltd",
    "name": "Maitland Institutional Services Ltd",
    "value": ["0C0000B4F9"]
  },
  {
    "id": "Man Group",
    "name": "Man Group",
    "value": ["0C000035NK", "0C00001PGK"]
  },
  {
    "id": "Margetts Fund Management",
    "name": "Margetts Fund Management",
    "value": ["0C00001PIN"]
  },
  { "id": "Marlborough", "name": "Marlborough", "value": ["0C000033S5"] },
  {
    "id": "Matthews Intl Capital Management",
    "name": "Matthews Intl Capital Management",
    "value": ["0C000055VG"]
  },
  {
    "id": "McInroy & Wood",
    "name": "McInroy & Wood",
    "value": ["0C00001TZ0"]
  },
  {
    "id": "MFS International",
    "name": "MFS International",
    "value": ["0C0000BZV7"]
  },
  { "id": "Mirabaud", "name": "Mirabaud", "value": ["0C0000927J"] },
  {
    "id": "MitonOptimal UK Limited",
    "name": "MitonOptimal UK Limited",
    "value": ["0C00001TZA"]
  },
  { "id": "Montanaro", "name": "Montanaro", "value": ["0C000033HE"] },
  {
    "id": "Morant Wright Management Ltd",
    "name": "Morant Wright Management Ltd",
    "value": ["0C0000490R"]
  },
  {
    "id": "Morgan Stanley Investment Management",
    "name": "Morgan Stanley Investment Management",
    "value": ["0C00002YV7", "0C00001PUD", "0C0000ANOX"]
  },
  {
    "id": "Mori Capital Management Limited",
    "name": "Mori Capital Management Limited",
    "value": ["0C0000B4DQ"]
  },
  { "id": "Muzinich", "name": "Muzinich", "value": ["0C0000AO7E"] },
  {
    "id": "Natixis Investment Managers S.A.",
    "name": "Natixis Investment Managers S.A.",
    "value": ["0C00001PZ3", "0C0000A4NA"]
  },
  {
    "id": "NB Asset Management Ireland Ltd",
    "name": "NB Asset Management Ireland Ltd",
    "value": ["0C00003IFY", "0C0000BTTC"]
  },
  {
    "id": "Nedgroup Investments (IOM) Ltd",
    "name": "Nedgroup Investments (IOM) Ltd",
    "value": ["0C00001PZV"]
  },
  {
    "id": "Neuberger Berman",
    "name": "Neuberger Berman",
    "value": ["0C00001EI2", "0C00003FIF"]
  },
  {
    "id": "New Capital",
    "name": "New Capital",
    "value": ["0C00009EOQ", "0C0000BLOT", "0C00003HSR"]
  },
  {
    "id": "Ninety One",
    "name": "Ninety One",
    "value": ["0C00001OP5", "0C00001THB"]
  },
  {
    "id": "Nomura Asset Management U.K. Limited",
    "name": "Nomura Asset Management U.K. Limited",
    "value": ["0C00001CX5"]
  },
  {
    "id": "Northern Trust Fund Managers (Ireland) Limited",
    "name": "Northern Trust Fund Managers (Ireland) Limited",
    "value": ["0C000021EY"]
  },
  {
    "id": "Octopus Investments",
    "name": "Octopus Investments",
    "value": ["0C00001Q7S", "0C0000C6R0"]
  },
  { "id": "Odey", "name": "Odey", "value": ["0C0000348U"] },
  { "id": "Oldfield", "name": "Oldfield", "value": ["0C00001Q93"] },
  {
    "id": "Orbis Investment Management Limited",
    "name": "Orbis Investment Management Limited",
    "value": ["0C00001QBG"]
  },
  {
    "id": "Pacific Capital Partners Limited",
    "name": "Pacific Capital Partners Limited",
    "value": ["0C0000AN8E"]
  },
  { "id": "PGIM, Inc", "name": "PGIM, Inc", "value": ["0C0000B1UI"] },
  { "id": "Pictet", "name": "Pictet", "value": ["0C00001QJF"] },
  { "id": "PIMCO", "name": "PIMCO", "value": ["0C00001QJZ"] },
  {
    "id": "Polar Capital",
    "name": "Polar Capital",
    "value": ["0C00001D2F"]
  },
  {
    "id": "Polen Capital Management, LLC",
    "name": "Polen Capital Management, LLC",
    "value": ["0C00001E3J"]
  },
  {
    "id": "Premier Miton",
    "name": "Premier Miton",
    "value": ["0C00001QNA", "0C00001QND"]
  },
  {
    "id": "Prescient Fund Services (Ireland) Limited",
    "name": "Prescient Fund Services (Ireland) Limited",
    "value": ["0C0000AZC8"]
  },
  {
    "id": "Prusik Investment Management LLP",
    "name": "Prusik Investment Management LLP",
    "value": ["0C00001QS7"]
  },
  {
    "id": "Pzena Investment Management Europe Limited",
    "name": "Pzena Investment Management Europe Limited",
    "value": ["0C0000CRRY"]
  },
  {
    "id": "Quadris Environmental Fund PLC",
    "name": "Quadris Environmental Fund PLC",
    "value": ["0C00001TTH"]
  },
  {
    "id": "Quaero Capital LLP",
    "name": "Quaero Capital LLP",
    "value": ["0C00003GBZ"]
  },
  { "id": "Quilter", "name": "Quilter", "value": ["0C00009V0Z"] },
  {
    "id": "Ranmore Fund Management LTD",
    "name": "Ranmore Fund Management LTD",
    "value": ["0C00006BH7"]
  },
  {
    "id": "Rathbone Unit Trust Management",
    "name": "Rathbone Unit Trust Management",
    "value": ["0C00001QWO"]
  },
  { "id": "RBS", "name": "RBS", "value": ["0C000049LY", "0C00001QXE"] },
  {
    "id": "River & Mercantile",
    "name": "River & Mercantile",
    "value": ["0C00001R17"]
  },
  { "id": "Royal London", "name": "Royal London", "value": ["0C00001R4N"] },
  {
    "id": "Rubrics Asset Management",
    "name": "Rubrics Asset Management",
    "value": ["0C0000BLK2"]
  },
  {
    "id": "Ruffer",
    "name": "Ruffer",
    "value": ["0C0000B1X6", "0C000033AO", "0C0000490W"]
  },
  {
    "id": "S. W. Mitchell Capital LLP",
    "name": "S. W. Mitchell Capital LLP",
    "value": ["0C00004J5R"]
  },
  {
    "id": "Sand Aire Limited",
    "name": "Sand Aire Limited",
    "value": ["0C00001R80"]
  },
  {
    "id": "Sands Capital Management, LLC",
    "name": "Sands Capital Management, LLC",
    "value": ["0C00001GN8"]
  },
  {
    "id": "Sanlam Investments",
    "name": "Sanlam Investments",
    "value": ["0C0000AOU1"]
  },
  {
    "id": "Santander Asset Management",
    "name": "Santander Asset Management",
    "value": ["0C00001R8N"]
  },
  {
    "id": "Sarasin & Partners",
    "name": "Sarasin & Partners",
    "value": ["0C00008WTH", "0C00001R9C"]
  },
  {
    "id": "Schroders",
    "name": "Schroders",
    "value": [
      "0C000034II",
      "0C000023PM",
      "0C00008O17",
      "0C000021A9",
      "0C0000CTV8"
    ]
  },
  {
    "id": "Scottish Widows",
    "name": "Scottish Widows",
    "value": ["0C0000BVIC", "0C00001RCP"]
  },
  {
    "id": "Seneca",
    "name": "Seneca",
    "value": ["0C00001PQB", "0C0000AXD8"]
  },
  {
    "id": "SEI Investments Global Limited",
    "name": "SEI Investments Global Limited",
    "value": ["0C00001REQ"]
  },
  {
    "id": "Seilern Inv Mgmt Ireland Ltd",
    "name": "Seilern Inv Mgmt Ireland Ltd",
    "value": ["0C00001REW"]
  },
  { "id": "SKAGEN AS", "name": "SKAGEN AS", "value": ["0C00001RL3"] },
  {
    "id": "Slater Investments",
    "name": "Slater Investments",
    "value": ["0C00001RM2"]
  },
  {
    "id": "Smith & Williamson",
    "name": "Smith & Williamson",
    "value": ["0C00004I4R", "0C000052MN"]
  },
  {
    "id": "SPARX Funds PLC",
    "name": "SPARX Funds PLC",
    "value": ["0C00009F04"]
  },
  {
    "id": "Somerset Capital Management",
    "name": "Somerset Capital Management",
    "value": ["0C00003GGY"]
  },
  {
    "id": "State Street",
    "name": "State Street",
    "value": ["0C0000C8SV", "0C000052GU", "0C00001RT4"]
  },
  {
    "id": "Stewart Investors",
    "name": "Stewart Investors",
    "value": ["0C0000B4Q6"]
  },
  { "id": "Stonehage", "name": "Stonehage", "value": ["0C0000B0DB"] },
  { "id": "SVM", "name": "SVM", "value": ["0C00001RWL"] },
  {
    "id": "T. Bailey Fund Managers",
    "name": "T. Bailey Fund Managers",
    "value": ["0C00001RYY"]
  },
  {
    "id": "T. Rowe Price",
    "name": "T. Rowe Price",
    "value": ["0C00008QVP", "0C0000BPLQ"]
  },
  {
    "id": "Threadneedle",
    "name": "Threadneedle",
    "value": ["0C00001S4W", "0C00004HUU"]
  },
  { "id": "Thesis", "name": "Thesis", "value": ["0C00001S40"] },
  { "id": "Thornbridge", "name": "Thornbridge", "value": ["0C0000B9ZJ"] },
  {
    "id": "Tideway Investment Partners LLP",
    "name": "Tideway Investment Partners LLP",
    "value": ["0C000093PF"]
  },
  { "id": "Triodos", "name": "Triodos", "value": ["0C000033NG"] },
  {
    "id": "Trium Ireland Ltd",
    "name": "Trium Ireland Ltd",
    "value": ["0C0000BS3U"]
  },
  {
    "id": "Troy Asset Management",
    "name": "Troy Asset Management",
    "value": ["0C00001S8W"]
  },
  { "id": "TUTMAN LLP", "name": "TUTMAN LLP", "value": ["0C0000B1GI"] },
  { "id": "TwentyFour", "name": "TwentyFour", "value": ["0C000054Y4"] },
  {
    "id": "UBS",
    "name": "UBS",
    "value": [
      "0C00001SAU",
      "0C00001W1F",
      "0C00001UUQ",
      "0C00008TJR",
      "0C00001SC7",
      "0C00001SCG"
    ]
  },
  { "id": "Unicorn", "name": "Unicorn", "value": ["0C00001SD8"] },
  {
    "id": "UTI International (Singapore) Pvt. Ltd.",
    "name": "UTI International (Singapore) Pvt. Ltd.",
    "value": ["0C000069AI"]
  },
  {
    "id": "Valu-Trac Investment Management",
    "name": "Valu-Trac Investment Management",
    "value": ["0C00001SGI"]
  },
  {
    "id": "Vanguard",
    "name": "Vanguard",
    "value": ["0C000022HA", "0C00003GNE"]
  },
  {
    "id": "Veritas Asset Management",
    "name": "Veritas Asset Management",
    "value": ["0C00001SIB"]
  },
  { "id": "Waverton", "name": "Waverton", "value": ["0C0000AN5D"] },
  {
    "id": "Way Fund Managers",
    "name": "Way Fund Managers",
    "value": ["0C00001SMD"]
  },
  {
    "id": "Waystone",
    "name": "Waystone",
    "value": ["0C0000B3GM", "0C00009UT8", "0C0000C6HT", "0C000035NI"]
  },
  { "id": "Winton", "name": "Winton", "value": ["0C0000C1YY"] },
  {
    "id": "WisdomTree",
    "name": "WisdomTree",
    "value": [
      "0C000024EC",
      "0C0000A4AG",
      "0C000099B1",
      "0C00009UKT",
      "0C0000BQUU",
      "0C0000ARAP",
      "0C00004D76",
      "0C00009PFL",
      "0C0000CFFN"
    ]
  },
  {
    "id": "Witan Investment Services Limited",
    "name": "Witan Investment Services Limited",
    "value": ["0C00002Z1H"]
  },
  {
    "id": "Yealand Fund Services",
    "name": "Yealand Fund Services",
    "value": ["0C000091WB"]
  }
];

const LARGEST_SECTOR_DATA = [
  {
    "id": "SB_BasicMaterials",
    "name": "Basic Materials"
  },
  {
    "id": "SB_CommunicationServices",
    "name": "Communication Services"
  },
  {
    "id": "SB_ConsumerCyclical",
    "name": "Consumer Cyclical"
  },
  {
    "id": "SB_ConsumerDefensive",
    "name": "Consumer Defensive"
  },
  {
    "id": "SB_Energy",
    "name": "Energy"
  },
  {
    "id": "SB_FinancialServices",
    "name": "Financial Services"
  },
  {
    "id": "SB_Healthcare",
    "name": "Healthcare"
  },
  {
    "id": "SB_Industrials",
    "name": "Industrials"
  },
  {
    "id": "SB_RealEstate",
    "name": "RealEstate"
  },
  {
    "id": "SB_Technology",
    "name": "Technology"
  },
  {
    "id": "SB_Utilities",
    "name": "Utilities"
  }
];

const REGION_EXCHANGE_DATA = [
  { "id": ["EX$$$$XLON"], "name": "UK" },
  { "id": ["EX$$$$XNAS", "EX$$$$XNYS", "EX$$$$XASE"], "name": "US" },
  {
    "id": [
      "EX$$$$XPAR",
      "EX$$$$XSTO",
      "EX$$$$XAMS",
      "EX$$$$XSWX",
      "EX$$$$XMAD",
      "EX$$$$XMIL",
      "EX$$$$XETR"
    ],
    "name": "Europe"
  },
  { "id": ["EX$$$$XTSE"], "name": "Canada" }
];

const MANAGEMENT_STYLE_DATA = [
  { "name": "Active", "id": "Active", "value": "false" },
  {
    "content": "Active management funds aims to outperform a specific benchmark or index.",
    "type": "content"
  },
  { "name": "Passive", "id": "Passive", "value": "true" },
  {
    "content": "Passive management replicates a specific benchmark or index in order to match its performance.",
    "type": "content"
  }
];

const LARGEST_REGION_DATA = [
  { "id": "RE_UnitedKingdom", "name": "United Kingdom" },
  { "id": "RE_UnitedStates", "name": "United States" },
  { "id": "RE_WesternEuropeEuro", "name": "Western Europe euro" },
  { "id": "RE_WesternEuropeNonEuroexUK", "name": "Western Europe non euro ex UK" },
  { "id": "RE_Japan", "name": "Japan" },
  { "id": "RE_Asia4TigersEmerging", "name": "Asia 4 tigers emerging" },
  { "id": "RE_Asiaex4TigersEmerging", "name": "Asia emerging ex 4 tigers" },
  { "id": "RE_Canada", "name": "Canada" },
  { "id": "RE_Australasia", "name": "Australasia" },
  { "id": "RE_CentralandEasternEurope", "name": "Central and eastern Europe" },
  { "id": "RE_CentralandLatinAmericaEmerging", "name": "Central and Latin America" },
  { "id": "RE_AfricaDeveloped", "name": "Africa developed" },
  { "id": "RE_AfricaEmerging", "name": "Africa emerging" }
];

const INCOME_GROWTH_DATA = [
  { "name": "Income", "id": "inc" },
  {
    "content": "Any income the fund produces will be paid into your AJ Bell account as cash. You can then decide what you want to do with it. Usually used by investors whose overall goal is income.",
    "type": "content"
  },
  { "name": "Accumulation", "id": "acc" },
  {
    "content": "Any income the fund produces will be reinvested back into the fund by the manager, increasing the price of the units. Usually used by investors whose overall goal is growth.",
    "type": "content"
  }
];

const PERFORMANCE_DATA = [
  {
    "content": "Performance (1 Year)",
    "type": "content"
  },
  { "name": "< 0.5%", "value": "LTE:0.5", "id": "Income1", "section": "0" },
  {
    "name": "0.5% - 1%",
    "value": "BTW:0.5:1",
    "id": "Income2",
    "section": "0"
  },
  {
    "name": "1% - 1.5%",
    "value": "BTW:1:1.5",
    "id": "Income3",
    "section": "0"
  },
  { "name": "> 1.5%", "value": "GTE:1.5", "id": "Income4", "section": "0" },
  {
    "content": "Performance (3 Year)",
    "type": "content"
  },
  {
    "name": "0% to 10%",
    "value": "BTW:0:10",
    "id": "Income5",
    "section": "1"
  },
  {
    "name": "10% to 20%",
    "value": "BTW:10:20",
    "id": "Income6",
    "section": "1"
  },
  {
    "name": "20% to 30%",
    "value": "BTW:20:30",
    "id": "Income7",
    "section": "1"
  },
  { "name": "30% +", "value": "GTE:30", "id": "Income8", "section": "1" },
  {
    "content": "Performance (5 Year)",
    "type": "content"
  },
  {
    "name": "0% to 20%",
    "value": "BTW:0:20",
    "id": "Income9",
    "section": "2"
  },
  {
    "name": "20% to 50%",
    "value": "BTW:20:50",
    "id": "Income10",
    "section": "2"
  },
  { "name": "50% +", "value": "GTE:50", "id": "Income11", "section": "2" }
];

const ONGOING_CHARGE_DATA = [
  {
    "content": "The % amount you'll pay for holding the fund, including the annual management fee. (This doesn't include additional costs such as transaction and performance fees).",
    "type": "content"
  },
  { "name": "< 0.5%", "value": "LTE:0.5", "id": "lessThanHalf" },
  { "name": "0.5% - 1%", "value": "BTW:0.5:1", "id": "btwHalfAnd1" },
  { "name": "1% - 1.5%", "value": "BTW:1:1.5", "id": "btw1And1Half" },
  { "name": "> 1.5%", "value": "GTE:1.5", "id": "moreThan1Half" }
];

const SRRI_DATA = [
  { "name": "1", "id": "1", "value": 1 },
  { "name": "2", "id": "2", "value": 2 },
  { "name": "3", "id": "3", "value": 3 },
  { "name": "4", "id": "4", "value": 4 },
  { "name": "5", "id": "5", "value": 5 },
  { "name": "6", "id": "6", "value": 6 },
  { "name": "7", "id": "7", "value": 7 }
];

const YIELD_DATA = [
  {
    "content": "The income the fund has returned to investors, expressed as a percentage. You can use this to gauge the potential income you could earn from the fund.",
    "type": "content"
  },
  { "name": "0% - 2%", "value": "BTW:0:2", "id": "less2" },
  { "name": "2% - 3%", "value": "BTW:2:3", "id": "btw2and3" },
  { "name": "3% - 4%", "value": "BTW:3:4", "id": "btw3and4" },
  { "name": "4% - 6%", "value": "BTW:4:6", "id": "btw4and6" },
  { "name": "6% +", "value": "GTE:6", "id": "more6" }
];

const EXCHANGE_DATA = [
  { "id": "EX$$$$XLON", "name": "London stock exchange" },
  { "id": "EX$$$$XNAS", "name": "NASDAQ" },
  { "id": "EX$$$$XNYS", "name": "NYS" },
  { "id": "EX$$$$XPAR", "name": "Euronext Paris" },
  { "id": "EX$$$$XSTO", "name": "Stockholm Stock Exchange" },
  { "id": "EX$$$$XAMS", "name": "Euronext Amsterdam" },
  { "id": "EX$$$$XSWX", "name": "SIX Swiss Exchange" },
  { "id": "EX$$$$XMAD", "name": "Bolsa de Madrid" },
  { "id": "EX$$$$XMIL", "name": "Borsa Italiana" },
  { "id": "EX$$$$XETR", "name": "Xetra" },
  { "id": "EX$$$$XTSE", "name": "Toronto Stock Exchange" },
  { "id": "EX$$$$XASE", "name": "American Stock Exchange" }
];

const FUND_SIZE_DATA = [
  { "name": "£0 - £10m", "value": "LTE:10000000", "id": "less10m" },
  {
    "name": "£10m - £50m",
    "value": "BTW:10000000:50000000",
    "id": "btw10m50m"
  },
  {
    "name": "£50m - £100m",
    "value": "BTW:50000000:100000000",
    "id": "btw50m100m"
  },
  {
    "name": "£100m - £500m",
    "value": "BTW:100000000:500000000",
    "id": "btw100m500m"
  },
  {
    "name": "£500m - £1bn",
    "value": "BTW:500000000:1000000000",
    "id": "btw500m1b"
  },
  { "name": "£1bn +", "value": "GTE:1000000000", "id": "more1b" }
];

const REPLICATION_METHOD_DATA = [
  {
    "content": "How the ETF replicates its index - either fully, partially or synthetically.",
    "type": "content"
  },
  {
    "name": "Physical Full",
    "id": "PhysicalFull",
    "value": "Physical Full"
  },
  {
    "name": "Physical Sample",
    "id": "PhysicalSample",
    "value": "Physical Sample"
  },
  {
    "name": "Synthetic Replication",
    "id": "SyntheticReplication",
    "value": "Synthetic Replication"
  }
];

const FIVE_CHOICE_OPTION = [
  { "name": "1", "id": "1", "value": 1 },
  { "name": "2", "id": "2", "value": 2 },
  { "name": "3", "id": "3", "value": 3 },
  { "name": "4", "id": "4", "value": 4 },
  { "name": "5", "id": "5", "value": 5 }
];

const PE_RATIO_DATA = [
  { "name": "< 0", "value": "LTE:0", "id": "lessThanZero" },
  { "name": "0 - 10", "value": "BTW:0:10", "id": "btwZeroAndTen" },
  { "name": "10 - 25", "value": "BTW:10:25", "id": "btwTenAndTwentyFive" },
  {
    "name": "25 - 50",
    "value": "BTW:25:50",
    "id": "btwTwentyFiveAndFifty"
  },
  {
    "name": "50 - 100",
    "value": "BTW:50:100",
    "id": "btwFiftyAndOneHundred"
  },
  {
    "name": "100 - 500",
    "value": "BTW:100:500",
    "id": "btwOneHundredAndFiveHundred"
  },
  { "name": "> 500", "value": "GTE:500", "id": "moreThanFiveHundred" }
];

const MARKET_CAP_DATA = [
  { "name": "< 150M", "value": "LTE:150000000", "id": "lessThan150M" },
  {
    "name": "150M - 500M",
    "value": "BTW:150000000:500000000",
    "id": "btw150MAnd500M"
  },
  {
    "name": "500M - 1B",
    "value": "BTW:500000000:1000000000",
    "id": "btw500MAnd1B"
  },
  {
    "name": "1B - 10B",
    "value": "BTW:1000000000:10000000000",
    "id": "btw1BAnd10B"
  },
  { "name": "> 10B", "value": "GTE:10000000000", "id": "moreThan10B" }
];

const filtersMapping = {
  "IMASectorId": {
    "ScreenType": ["Funds", "ETF"],
    "UILabel": "Sector",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "SectorId": {
    "ScreenType": ["Shares"],
    "UILabel": "Sector",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "LargestSector": {
    "ScreenType": ["Investment Trust"],
    "UILabel": "Sector",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": LARGEST_SECTOR_DATA
  },
  "Region": {
    "ScreenType": ["Shares"],
    "UILabel": "Region",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": REGION_EXCHANGE_DATA
  },
  "FundManagerMapping": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Provider",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": FUND_MANAGER_DATA
  },
  "ManagementStyle": {
    "ScreenType": ["Funds"],
    "UILabel": "Management Style",
    "isAdvancedFilter": false,
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": MANAGEMENT_STYLE_DATA
  },
  "AJBellSelectionFunds": {
    "ScreenType": ["Funds"],
    "UILabel": "AJ Bell Selection",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "AJBellSelectionETF": {
    "ScreenType": ["ETF"],
    "UILabel": "AJ Bell Selection",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "AJBellSelectionInvestmentTrust": {
    "ScreenType": ["Investment Trust"],
    "UILabel": "AJ Bell Selection",
    "isAdvancedFilter": false,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "LargestRegionNames": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Geographical region",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": LARGEST_REGION_DATA
  },
  "IncomeOrGrowth": {
    "ScreenType": ["Funds", "ETF"],
    "UILabel": "Income or Growth",
    "isAdvancedFilter": true,
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": INCOME_GROWTH_DATA
  },
  "Performance": {
    "ScreenType": ["Funds", "ETF", "Shares", "Investment Trust"],
    "UILabel": "Performance",
    "isAdvancedFilter": ["Funds", "ETF", "Investment Trust"],
    "isMultipleChoice": true,
    "isSectionBased": true,
    "data": PERFORMANCE_DATA
  },
  "OngoingCharge": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Ongoing fund charge",
    "isAdvancedFilter": true,
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": ONGOING_CHARGE_DATA
  },
  "SRRI": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Risk Rating",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": SRRI_DATA
  },
  "Yield": {
    "ScreenType": ["Funds", "ETF", "Shares", "Investment Trust"],
    "UILabel": "Yield",
    "isAdvancedFilter": ["Funds", "ETF", "Investment Trust"],
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": YIELD_DATA
  },
  "GlobalAssetClassId": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Asset class",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "Exchange": {
    "ScreenType": ["Shares"],
    "UILabel": "Exchange",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": EXCHANGE_DATA
  },
  "FundSize": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Fund Size",
    "isAdvancedFilter": true,
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": FUND_SIZE_DATA
  },
  "ReplicationMethod": {
    "ScreenType": ["ETF"],
    "UILabel": "Replication Method",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": REPLICATION_METHOD_DATA
  },
  "MorningStarRating": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Morningstar Rating",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": [
      {
        "content": "Morningstar rates investments from one to five stars based on how well they&apos;ve performed in comparison to similar investments, after adjusting for risk and accounting for all relevant sales charges.",
        "type": "content"
      },
      ...FIVE_CHOICE_OPTION
    ]
  },
  "MorningSustainabilityRating": {
    "ScreenType": ["Funds", "ETF", "Investment Trust"],
    "UILabel": "Morningstar sustainability",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": [
      {
        "content": "The Morningstar Sustainability Rating is a reliable indicator to see if funds are meeting ESG challenges.",
        "type": "content"
      },
      ...FIVE_CHOICE_OPTION
    ]
  },
  "IndustryId": {
    "ScreenType": ["Shares"],
    "UILabel": "Industry",
    "isAdvancedFilter": true,
    "isMultipleChoice": true,
    "isSectionBased": false,
    "data": []
  },
  "PE_RATIO": {
    "ScreenType": ["Shares"],
    "UILabel": "P/E ratio",
    "isAdvancedFilter": true,
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": PE_RATIO_DATA
  },
  "MarketCapitalisation": {
    "ScreenType": ["Shares"],
    "UILabel": "Market Capitalisation",
    "isAdvancedFilter": false,
    "isMultipleChoice": false,
    "isSectionBased": false,
    "data": MARKET_CAP_DATA
  }
};

export default class MorningStar {

  async getMorningStarTokenResponse() {
    const response = await axios({
      method: 'GET',
      url: `${process.env.TRADING_ENDPOINT}/api/securities/morningstar-oauth-token`,
      headers: YouInvest.getTradingRequestHeaders()
    })
    return response.data;
  }

  async getFundScreenerResponse(filters) {
    let screenerType = '';
    let universeIds = '';

    switch (filters.screenerType) {
      case EQUITY:
        screenerType = 'filters=InvestmentTypeId:EQ:E0';
        break;
      case FUND:
        screenerType = 'filters=term=AJ%20Bell';
        universeIds = '&universeIds=FXALL$$ALL_1392';
        break;
      case ETF:
        screenerType = 'filters=InvestmentTypeId:EQ:FO|ExchangeTradedShare:EQ:true';
        break;
      case CEF:
        screenerType = 'filters=InvestmentTypeId:EQ:FO|LegalStructureId:EQ:05|ExchangeTradedShare:EQ:false';
        break;
    }

    let filterString = '';
    let searchString = '';
    const filterObject = {
      AdministratorCompanyId: '|AdministratorCompanyId:IN:',
      IMASectorId: '|IMASectorId:IN:',
      LargestSector: '|LargestSector:IN:',
      SectorId: '|SectorId:IN:',
      GlobalAssetClassId: '|GlobalAssetClassId:IN:',
      FundTNAV: '|FundTNAV:',
      Yield_M12: '|Yield_M12:',
      DividendYield: '|DividendYield:',
      Largestregion: '|Largestregion:IN:',
      SRRI: '|SRRI:IN:',
      StarRating: '|StarRating:IN:',
      SustainabilityRating: '|SustainabilityRating:IN:',
      LatestReportOngoingCharge: '|OngoingCharge:',
      ReturnM12: '|ReturnM12:',
      ReturnM36: '|ReturnM36:',
      ReturnM60: '|ReturnM60:',
      Distribution: '|Distribution:IN:',
      IndexFund: '|IndexFund:IN:',
      IndexingApproach: '|IndexingApproach:IN:',
      IndustryId: '|IndustryId:IN:',
      PERatio: '|PERatio:',
      ExchangeId: '|ExchangeId:IN:',
      MarketCap: '|MarketCap:'
    };

    for (let f in filterObject) {
      const filter = filterObject[f];
      let selectedFilterString = '';

      if (f === 'ExchangeId' && filters?.RegionExchangeId?.length) {
        const RegionExchangeString = filters.RegionExchangeId.map(a => a.join(":")).join(":");
        selectedFilterString = filters[f].length ? `${filters[f].join(':')}:` : '';

        filterString += filter + selectedFilterString + RegionExchangeString;
      } else if (filters[f] && filters[f].length > 0) {
        if (f === 'AdministratorCompanyId') {
          selectedFilterString = filters[f].map(a => a.join(":")).join(":");
        } else {
          selectedFilterString = filters[f].join(':');
        }

        filterString += filter + selectedFilterString;
      } else {
        filterString += '';
      }
    }

    if (filters.selectedFunds?.length) {
      filterString += '|Sedol:IN:' + filters.selectedFunds.join(':');
    }

    if (filters.screenerType === FUND) {
      filterString = this.filterSearchResults(filterString);
    }

    if (filters.search) {
      searchString = `&term=${filters.search}`;
    }

    const securityDataPoints = [
      'name',
      'sedol',
      'isin',
      'rating',
      'SustainabilityRating',
      'CustomBuyFee',
      'ReturnM0',
      'PerformanceFeeIndexName',
      'OngoingCharge',
      'StarRating',
      'RatingM36',
      'assetclass',
      'DividendYield',
      'ReturnM1',
      'ReturnM3',
      'ReturnM6',
      'ReturnM12',
      'ReturnM36',
      'ReturnM60',
      'ReturnM120',
      'ClosePriceChange',
      'Yield_M12',
      'Price',
      'ClosePrice',
      'Intraday.Bid',
      'Intraday.Ask',
      'ExchangeCode',
      'Symbol',
      'Medalist_RatingNumber',
      'PerformanceFeeIndexName',
      'CustomPerformanceFee',
      'ChargeAccumulation',
      'ReturnW1',
      'RealTimeSecurityType',
      'InvestmentTypeId',
      'ExchangeTradedShare',
      'LegalStructureName',
      'LegalStructureId',
      'universeId',
      'IMASectorId',
      'IMASectorName',
      'YR_ReturnM12_1',
      'YR_ReturnM12_2',
      'YR_ReturnM12_3',
      'YR_ReturnM12_4',
      'YR_ReturnM12_5',
      'Distribution',
      'currency',
      'MarketCap',
      'ROEYear1',
      'DebtEquityRatio',
      'PERatio',
      'PERatio5YrAverage',
      'DilutedContinuousEPSGrowthYear1',
      'priceCurrencyId',
      'DiscountPremium',
      'ReturnW1',
      'ReturnM120',
      'MIC'
    ];

    const response = await axios({
      method: 'GET',
      url: `${process.env.MORNINGSTAR_BASE_URL}/api/rest.svc/${process.env.SOLUTION_KEY}/security/screener?page=${filters.currentPage}&pageSize=${filters.rowsPerPage}${filters.sortOrder ? `&sortOrder=${filters.sortOrder.name}+${filters.sortOrder.order}` : ''}&outputType=json&version=1&languageId=en-GB&currencyId=GBP${universeIds}&tab=asset_info&securityDataPoints=${securityDataPoints.join(',')}&${screenerType}${filterString}${searchString}`
    })

    return response.data;
  }

  async getOldFiltersResponse() {
    const filterDataPoints = [
      'Region',
      'IMASectorId',
      'GlobalAssetClassId',
      'GlobalCategoryId',
      'FundTNAV',
      'Yield_M12',
      'YR_ReturnM12_1',
      'RiskRating',
      'StarRating',
      'SustainabilityRating',
      'LatestReportOngoingCharge',
      'Distribution',
      'IndexFund',
      'Largestregion',
      'IndexingApproach',
      'IndustryId',
      'PERatio',
      'ExchangeId',
      'MarketCap',
      'SRRI',
      'SectorId',
      'LargestSector'
    ];

    const response = await axios({
      method: 'GET',
      url: `${process.env.MORNINGSTAR_BASE_URL}/api/rest.svc/${process.env.SOLUTION_KEY}/security/screener?languageId=en-GB&currencyId=GBP&outputType=json&filterDataPoints=${filterDataPoints.join(',')}`
    });

    return response.data;
  }

  async getFiltersResponse() {
    const cache = new RedisCaching;
    let screenerFiltersObj = {};
    const compressedScreenerData = await cache.get(SCREENER_FILTERS_CACHE_KEY);

    if (!compressedScreenerData) {
      screenerFiltersObj = {};

      const ajbFundSedols = [];
      const favouriteFundSedols = [];
      const selectListSedols = [];

      const filterDataPoints = [
        'IMASectorId',
        'SectorId',
        'LargestSector',
        'Region',
        'FundManagerMapping',
        'ManagementStyle',
        'AJBellSelectionFunds',
        'AJBellSelectionETF',
        'AJBellSelectionInvestmentTrust',
        'LargestRegionNames',
        'IncomeOrGrowth',
        'Performance',
        'OngoingCharge',
        'SRRI',
        'Yield',
        'GlobalAssetClassId',
        'Exchange',
        'FundSize',
        'ReplicationMethod',
        'MorningStarRating',
        'MorningSustainabilityRating',
        'IndustryId',
        'PE_RATIO',
        'MarketCapitalisation'
      ];

      const response = await axios({
        method: 'GET',
        url: `${process.env.MORNINGSTAR_BASE_URL}/api/rest.svc/${process.env.SOLUTION_KEY}/security/screener?languageId=en-GB&currencyId=GBP&outputType=json&filterDataPoints=IMASectorId,GlobalAssetClassId,IndustryId,SectorId`
      })

      const favourites = await YouInvest.getFavouriteFunds();

      favourites.forEach(favourite => {
        const { sedol, belongsTo } = favourite;

        if (belongsTo.includes('ajbFunds')) {
          ajbFundSedols.push(sedol);
        } else if (belongsTo.includes('favoriteFunds')) {
          favouriteFundSedols.push(sedol);
        } else if (belongsTo.includes('investmentTrustSelectList')) {
          selectListSedols.push(sedol);
        }
      });

      const ajbellFundOptionArr = [
        { "name": "AJ Bell Funds", "id": "ajbFunds", "value": ajbFundSedols },
        {
          "content": "Filter to only see funds managed and provided by AJ Bell.",
          "type": "content"
        }
      ];

      const favouriteFundOptionArr = [
        {
          "name": "AJ Bell Favourite funds",
          "id": "favoriteFunds",
          "value": favouriteFundSedols
        },
        {
          "content": "The favourite funds features selected by our  investment specialists for their income and growth potential.",
          "type": "content"
        }
      ];

      const selectListOptionArr = [
        {
          "name": "Investment trust select list",
          "id": "investmentTrustSelectList",
          "value": selectListSedols
        },
        {
          "content": "The investment trust select list is chosen by our investment specialists, looking at number of factors including price,performance and size.",
          "type": "content"
        }
      ];

      const filtersData = response.data;
      const filtersDataObj = Object.assign({}, ...filtersData.filters[0]);

      filterDataPoints.forEach(filter => {
        if (filtersMapping[filter]) {
          screenerFiltersObj[filter] = filtersMapping[filter];
          if (filter === 'AJBellSelectionFunds') {
            screenerFiltersObj[filter].data = ajbellFundOptionArr.concat(favouriteFundOptionArr);
          } else if (filter === 'AJBellSelectionETF') {
            screenerFiltersObj[filter].data = favouriteFundOptionArr;
          } else if (filter === 'AJBellSelectionInvestmentTrust') {
            screenerFiltersObj[filter].data = selectListOptionArr;
          } else if (Array.isArray(filtersDataObj[filter]) && screenerFiltersObj[filter].data.length === 0) {
            screenerFiltersObj[filter].data = filtersDataObj[filter];
          }
        }
      });
      let compressedData = await compress(JSON.stringify(screenerFiltersObj));
      await cache.set(SCREENER_FILTERS_CACHE_KEY, CACHE_TIME_15_MINUTES, compressedData);
    } else {
      screenerFiltersObj = await decompress(compressedScreenerData);
      screenerFiltersObj = JSON.parse(screenerFiltersObj);
    }

    return screenerFiltersObj;
  }

  filterSearchResults(filterString) {
    const filteredInstruments = [
      'BS85SG4', // GB00BS85SG44 CAUTIOUS A GBP ACC
      'BQGG3G0', // GB00BQGG3G06 BALANCED A GBP ACC
      'BQGG3H1', // GB00BQGG3H13 ADVENTUROUS A GBP ACC
      'BQGG3J3' // GB00BQGG3J37 RESPONSIBLE GROWTH A GBP ACC
    ];

    return filterString += '|Sedol:NIN:' + filteredInstruments.join(':');
  }

  async getLoaderSettings() {

    const isProd = process.env.NODE_ENV == 'production';
    const apiTokenResponse = await this.getMorningStarTokenResponse();
    const { accessToken } = apiTokenResponse.data;

    // TODO decide if/where the 'uat' environment should be used

    return {
      configuration: {
        namespace: 'AJBell.OPP396510.marketsChart',
        environment: isProd ? 'prod' : 'qa',
      },
      componentSource: {
        instid: 'AJBE'
      },
      apiTokens: {
        apiGatewayToken: accessToken
      }
    };
  }

}
